<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :label="selectLabel"
    :value="value"
    @search="onSearch"
    :filterable="false"
    @input="(template) => $emit('input', template)"
    autocomplete="new-password"
  >
    <template #option="option">
      <div>{{ option.name }}</div>
      <div
        v-if="option.description"
        class="font-size-sm text-secondary"
      >
        {{ option.description }}
      </div>
    </template>
    <template #no-options="{ search, searching }">
      <template v-if="searching">
        No results found for
        <em>{{ search }}</em>
      </template>
      <em
        style="opacity: 0.7"
        v-else
      >Type to search for templates</em>
    </template>
  </v-select>
</template>

<script>
import { debounce as _debounce } from 'lodash';

export default {
  name: 'QuoteTemplatesSelect',
  props: {
    value: Object,
    id: {
      type: String,
      default: 'quote-template',
    },
    selectLabel: {
      type: String,
      default: 'name',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    filterParams: {
      type: Object,
      default: () => new Object(),
    },
    clientId: {
      type: Number,
      default: null,
    },
    placeholder: String,
  },
  data() {
    return {
      options: [],
    };
  },
  methods: {
    onSearch(text, loading) {
      if (text.length) {
        loading(true);
        this.filterTemplates(text, loading, this);
      }
    },
    filterTemplates: _debounce((text, loading, vm) => {
      const params = {
        ...vm.filterParams,
        text: text,
      };
      if (vm.clientId) {
        const clientParams = {
          ...params,
          client_id: vm.clientId,
        };

        vm.$quoteTemplatesAPI.getTemplates(clientParams).then((response) => {
          vm.options = response.quoteTemplates;
          loading(false);
        }).catch(() => {
          vm.options = [];
          loading(false);
        });
        return;
      }

      const unassignedParams = {
        ...params,
        client_unassigned: true,
        client_id: null,
      };

      vm.$quoteTemplatesAPI.getTemplates(unassignedParams).then((response) => {
        vm.options = response.quoteTemplates;
        loading(false);
      }).catch(() => {
        vm.options = [];
        loading(false);
      });
    }, 500),
  },
  watch: {
    clientId(newClientId, oldClientId) {
      if (newClientId !== oldClientId) {
        this.options = [];
      }
    },
  },
};
</script>
